<div class="modal-header border-0">
    <div class="d-flex gap-3 align-items-center">
      <button class="btn btn-primary bg-transparent rounded-0 border-0" id="myModal"  aria-label="Close"
      (click)="backClick()">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="36" height="36" rx="18" fill="#100C43" />
          <g clip-path="url(#clip0_471_141)">
            <path
              d="M14.5232 17.1664L18.9932 12.6964L17.8148 11.5181L11.3332 17.9997L17.8148 24.4814L18.9932 23.3031L14.5232 18.8331H24.6665V17.1664H14.5232Z"
              fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_471_141">
              <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 28 8)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <!-- <img [src]='environment1 + "assets/images/advancesearch/search-icon.png"' class="img-fluid" alt="search-icon"  loading="lazy" > -->
    </div>
    <div class="steper mx-auto text-white">
      <div class="title mb-2">
        Please complete all the steps to see the models best suited to your
        business
      </div>
      <div class="d-flex item-box gap-4 gap-md-5">
        <div class="item"
          [ngClass]="{'active current': (breadcrumb?.l1_actual_name != '' && breadcrumb?.l2_actual_name == '')}">
          <div class="item-t">01. Search</div>
          <div class="tt da-flex align-items-center gap-1 cursor" id="searchBtn" #searchBtn
            data-bs-target="#searchConsoleDefult" aria-label="Close" (click)="valueChanged('search1')"
            *ngIf="breadcrumb?.l1_actual_name">{{breadcrumb?.l1_actual_name}} <svg width="17" height="16"
              viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_489_1594)">
                <path
                  d="M8.50048 7.05732L11.8005 3.75732L12.7431 4.69999L9.44315 7.99999L12.7431 11.3L11.8005 12.2427L8.50048 8.94266L5.20048 12.2427L4.25781 11.3L7.55781 7.99999L4.25781 4.69999L5.20048 3.75732L8.50048 7.05732Z"
                  fill="#00A925" />
              </g>
              <defs>
                <clipPath id="clip0_489_1594">
                  <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="item "
          [ngClass]="{'active current': (breadcrumb?.l2_actual_name != '' && breadcrumb?.l3_actual_name == '')}">
          <div class="item-t">02. Type</div>
          <div class="tt da-flex align-items-center gap-1 cursor" data-bs-target="#searchConsoleDefult2"
             id="search2btn" #search2btn (click)="valueChanged('search2')"
            *ngIf="breadcrumb?.l2_actual_name">{{breadcrumb?.l2_actual_name}} <svg width="17" height="16"
              viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_489_1594)">
                <path
                  d="M8.50048 7.05732L11.8005 3.75732L12.7431 4.69999L9.44315 7.99999L12.7431 11.3L11.8005 12.2427L8.50048 8.94266L5.20048 12.2427L4.25781 11.3L7.55781 7.99999L4.25781 4.69999L5.20048 3.75732L8.50048 7.05732Z"
                  fill="#00A925" />
              </g>
              <defs>
                <clipPath id="clip0_489_1594">
                  <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="item"
          [ngClass]="{'active current': (breadcrumb?.l3_actual_name != '' && breadcrumb?.l4_actual_name == '')}">
          <div class="item-t">03. Vehicle</div>
          <div class="tt da-flex align-items-center gap-1 cursor" data-bs-target="#searchConsoleDefult3"
             id="search3btn" #search3btn (click)="valueChanged('search3')"
            *ngIf="breadcrumb?.l3_actual_name">{{breadcrumb?.l3_actual_name}} <svg width="17" height="16"
              viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_489_1594)">
                <path
                  d="M8.50048 7.05732L11.8005 3.75732L12.7431 4.69999L9.44315 7.99999L12.7431 11.3L11.8005 12.2427L8.50048 8.94266L5.20048 12.2427L4.25781 11.3L7.55781 7.99999L4.25781 4.69999L5.20048 3.75732L8.50048 7.05732Z"
                  fill="#00A925" />
              </g>
              <defs>
                <clipPath id="clip0_489_1594">
                  <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="item" [ngClass]="{'active current': breadcrumb?.l4_actual_name != ''}">
          <div class="item-t">04. Smart Select</div>
          <div class="tt da-flex align-items-center gap-1 cursor"  data-bs-target="#searchConsoleDefult4"
           id="search4btn" #search4btn (click)="valueChanged('search4')"
          *ngIf="breadcrumb?.l4_actual_name">
            {{TotalCounts}}  Filter selected <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_489_1594)">
                <path
                  d="M8.50048 7.05732L11.8005 3.75732L12.7431 4.69999L9.44315 7.99999L12.7431 11.3L11.8005 12.2427L8.50048 8.94266L5.20048 12.2427L4.25781 11.3L7.55781 7.99999L4.25781 4.69999L5.20048 3.75732L8.50048 7.05732Z"
                  fill="#00A925" />
              </g>
              <defs>
                <clipPath id="clip0_489_1594">
                  <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="input-search mt-4">
      <input type="text" class="form-control" placeholder="Type Tata trucks" />
      <div class="search-modal-auto" id="modalAuto">
  
      </div>
    </div> -->
    <button type="button" class="btn-close" aria-label="Close" id="btnclose" #btnclose (click)="GoHome()"></button>
  </div>
  